
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { useComments } from "./CommentsContext";

interface CommentProps {
  comment: any;
  userAuthenticated: boolean;
}

export function Comment({ comment, userAuthenticated }: CommentProps) {
  const { setReplyTo } = useComments();

  return (
    <div className="space-y-3">
      <div className="flex gap-3 p-3 rounded-lg hover:bg-muted/20">
        <Avatar className="h-8 w-8">
          <AvatarImage src={comment.profile?.avatar_url} />
          <AvatarFallback>
            {comment.profile?.username?.charAt(0)?.toUpperCase() || "U"}
          </AvatarFallback>
        </Avatar>
        <div className="flex-1">
          <div className="flex items-start justify-between">
            <div>
              <span className="font-medium">{comment.profile?.username}</span>
              <span className="text-xs text-muted-foreground ml-2">
                {new Date(comment.created_at).toLocaleDateString()}
              </span>
            </div>
          </div>
          <p className="mt-1">{comment.content}</p>
          {userAuthenticated && (
            <Button 
              variant="ghost" 
              size="sm" 
              className="mt-2"
              onClick={() => setReplyTo({
                id: comment.id,
                username: comment.profile?.username
              })}
            >
              Responder
            </Button>
          )}
        </div>
      </div>

      {comment.replies && comment.replies.length > 0 && (
        <div className="ml-8 space-y-3">
          {comment.replies.map((reply: any) => (
            <div key={reply.id} className="flex gap-3 p-3 rounded-lg hover:bg-muted/20 border-l-2 border-muted">
              <Avatar className="h-6 w-6">
                <AvatarImage src={reply.profile?.avatar_url} />
                <AvatarFallback>
                  {reply.profile?.username?.charAt(0)?.toUpperCase() || "U"}
                </AvatarFallback>
              </Avatar>
              <div className="flex-1">
                <div>
                  <span className="font-medium">{reply.profile?.username}</span>
                  <span className="text-xs text-muted-foreground ml-2">
                    {new Date(reply.created_at).toLocaleDateString()}
                  </span>
                </div>
                <p className="mt-1">{reply.content}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
